<template>
  <el-header class="elheaderbox">
    <div class="topview">
      <div class="left" @click="goHome">
        <img class="img" src="@/assets/logo.png" lazy-load="false" binderror="" bindload="" />
        <div>
          <div class="span1">亿嘉安</div>
          <div class="span2">智能化项目安装施工服务平台</div>
          <div class="span3">400-669-6966</div>
        </div>
      </div>
      <div class="right">
        <div v-for="(item,index) in dataList" :key="index" class="rightitem rightitem1"
          :class="{active: isActive(item.path)}" @click="gotoPath(item)">
          <span class="pr">{{ item.name }}</span>
        </div>
        <el-dropdown placement="bottom">
          <el-button class="brbuttonbox">
            <div class="rightitem rightitem2">
              <span>扫码关注</span>
            </div>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <div class="dropdownbox">
                <div class="dropdownitem">
                  <img src="@/assets/img/home/m1.png" alt="">
                  <div class="text">关注公众号</div>
                </div>
                <div class="dropdownitem">
                  <img src="@/assets/img/home/m2.png" alt="">
                  <div class="text">亿嘉安用户端</div>
                </div>
                <div class="dropdownitem">
                  <img src="@/assets/img/home/m3.png?v=111" alt="">
                  <div class="text">亿嘉安师傅端</div>
                </div>
              </div>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <!-- login -->
        <div class="loginbox">
          <!-- 已登录 -->
          <div v-if="userInfo" class="loginokitem">
            <img :src="userInfo.data.user.photoUrl || mrtxing" alt="">
            <span>{{ xingPhone(userInfo.data.user.personalPhone) }}</span>
          </div>
          <!-- 未登录 -->
          <el-button class="loginbtn" @click="drawerTap" type="primary" v-else>
            <p>登录</p>
          </el-button>
        </div>
      </div>
    </div>
    <el-drawer :visible.sync="drawer" :size="`10rem`" class="drawerbox" direction="rtl">
      <div class="login-content pr">
        <div class="from-box center-self-xy">
          <div class="formboxtitle clearfix">
            <h3 :class="['fl', 'pr' ,'psdflg',!isW?'active':'']" @click="mmLoginTitTap">免密登录</h3>
            <h3 :class="['fr' ,'pr' ,'ewmflg',isW?'active':'']" @click="wxLoginTitTap">微信登录</h3>
          </div>
          <!-- 会员免密登录 -->
          <div class="frompsdbox " v-show="!isW">
            <!-- 手机号 -->
            <div class="tel-box pr">
              <input type="text" maxlength="11" v-model="phoneNumber" @input="phoneChange" placeholder="输入手机号" :disabled="isgetma" class="number-ipt">
            </div>
            <!-- 手机验证码 -->
            <div class="text-ma text-ma-sj clearfix pr">
              <input type="text" maxlength="6" v-model="yzmNum" @input="yzmChange" placeholder="输入验证码" class="fl yzm-ipt yzm-ma">
              <div class="ma-box center-self-y get-ma-one bg-sel " v-show="!isgetma&&!phoneflg">获取验证码</div>
              <div class="ma-box center-self-y get-ma-two " v-show="!isgetma&&phoneflg" @click="getYzmTap">获取验证码</div>
              <div class="ma-box center-self-y get-ma-three" v-show="isgetma">{{time}}</div>
            </div>
            <!-- 登录按钮 -->
            <button class="old-btn " v-show="!yzmflg || !phoneflg">提交</button>
            <button class="submit-btn" v-show="yzmflg && phoneflg" @click="submitLogin">提交</button>
            <div class="logo-bott">
              <p>未注册的手机号验证后将自动创建亿嘉安平台账号</p>
              <p>登录即代表您已同意
                <a href="javascript:;" @click="gotoAgreement(1)">《用户协议》</a>
                和
                <a href="javascript:;" @click="gotoAgreement(2)">《隐私政策》</a>
              </p>
            </div>
            <Vcode :show="isShow" :canvasWidth="520" :canvasHeight="280" :imgs="[Img1, Img2,Img3,Img4,Img5]" @success="onSuccess" @close="onClose" />
          </div>
          <!-- 微信登录 -->
          <div class="fromewmbox " v-show="isW">
            <div id="ewmbox">
              <img v-if="loginMaImg" :src="basestr+loginMaImg" alt="亿嘉安二维码">
            </div>
            <p>打开微信扫一扫，快速登录/注册</p>
          </div>
        </div>
      </div>
    </el-drawer>
  </el-header>
</template>
<script>
import stringutil from '@/common/stringutil'
import { Message } from 'element-ui';
import Vcode from "vue-puzzle-vcode";
import Img1 from "@/assets/img/login/1.png";
import Img2 from "@/assets/img/login/2.png";
import Img3 from "@/assets/img/login/3.png";
import Img4 from "@/assets/img/login/4.png";
import Img5 from "@/assets/img/login/5.png";
export default {
  name: 'TopView',
  props: {
    
  },
  components:{
    Vcode
  },
  data() {
    return {
      isShow:false,
      Img1,
      Img2,
      Img3,
      Img4,
      Img5,
      mrtxing:'https://csstss.cn/consumer/2024-11-05/80c1eb0c-e861-42cf-8e98-a52739da9d16.png',
      userInfo:'',
      intervalId: null,
      basestr: 'data:image/png;base64,',
      temporarySignUuid: '',
      loginMaImg:'',
      isgetma: false,
      time: '60',
      isW:false,
      phoneflg: false,
      yzmflg: false,
      drawer: false,
      phoneNumber: '',
      yzmNum:'',
      dataList:[
        {
          name: '首页',
          id: '0',
          sel: true,
          path: '/'
        },
        {
          name: '服务保障',
          id: '1',
          sel: false,
          path: '/Service'
        },
        {
          name: '专业维修',
          id: '2',
          sel: false,
          path: '/Maintenance'
        },
        {
          name: '安防学院',
          id: '3',
          sel: false,
          path: '/School'
        },
        {
          name: '前沿资讯',
          id: '4',
          sel: false,
          path: '/Information'
        },
        {
          name: '关于我们',
          id: '5',
          sel: false,
          path: '/Aboutus'
        }
      ]
    }
  },
  computed: {

  },
  created(){
    this.userInfo = this.common.getLocalStorageAndTime('userInfo') || '';
  },
  mounted() {
    
  },
  methods: {
    onSuccess(msg) {
      // console.log(msg)
      this.isShow = false; // 通过验证后，需要手动关闭模态框
      let options = {
        type: "MOBILE",
        mobileNo: this.phoneNumber,
        mobileCountryCode: "86"
      }
      this.$http.post("/web/sendVerificationCode", this.common.request(options))
      .then(res => {
          console.log(res)
          if (res.data.body.status.statusCode == '0') {
            var time = 60;
            var timeStart = null;
            if (!timeStart) {
              this.isgetma = true;
              timeStart = setInterval(() => {
                if (time > 1) {
                  time--;
                  this.time = time + 's';
                } else {
                  clearInterval(timeStart);
                  this.isgetma = false;
                  this.time = '60';
                  timeStart = null;
                }
              }, 1000)
            }
          }
      }, error => {
        // this.$message({
        //   showClose: true,
        //   message: error.data.msg,
        //   type: 'error'
        // });
      })
    },

    onClose() {
      this.isShow = false;
    },
    gotoAgreement(num){
      this.$router.push({ path: '/Agreement/'+num });
    },
    submitLogin() {
      let options = {
        verificationCode: this.yzmNum,
        personalPhone: this.phoneNumber,
        personalPhoneCountryCode: '86'
      }
      this.$http.post('/web/user/smsLogin', this.common.request(options))
      .then(res => {
        if (res.data.code == 200) {
          this.common.setLocalStorageAndTime('userInfo',{data:res.data.data});
          this.$router.go(0);
        }else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: 'error'
          });
        }
      }, error => {
        this.$message({
          showClose: true,
          message: error.data.msg,
          type: 'error'
        });
      })
    },
    xingPhone(phoneNum){
      let tel = String(phoneNum);
      let newTel = tel.slice(0,3) + "****" + tel.slice(7)
      return newTel;
    },
    drawerTap(){
      this.drawer = true
    },
    getYzmTap() {
      this.isShow = true;
    },
    mmLoginTitTap(){
      if(this.isW){
        this.isW = false;
      }
    },
    wxLoginTitTap(){
      if(!this.isW){
        this.isW = true;
        let _id = stringutil.getRandomNumber(8);
        this.temporarySignUuid = _id;
        this.getLoginMaFn(_id);
      }
    },
    // 获取登录小程序二维码
    getLoginMaFn(id){
      let options = {
        temporarySignUuid: id
      }
      this.$http.post("/web/user/getLoginQRCode", this.common.request(options))
      .then(res => {
          console.log(res)
          if (res.data.code == 200) {
            this.loginMaImg = res.data.data;
            this.intervalId = setInterval(this.isLoginFn, 5000);
          } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              });
          }
      }, error => {
        this.$message({
          showClose: true,
          message: error.data.msg,
          type: 'error'
        });
      })
    },
    // 是否登录
    isLoginFn(){
      // let that = this;
      let options = {
        temporarySignUuid: this.temporarySignUuid
      }
      this.$http.post("/web/user/findUserLoginStatusMessage", this.common.request(options))
      .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.common.setLocalStorageAndTime('userInfo',{data:res.data.data});
            clearInterval(this.intervalId);
            this.$router.go(0);
          }
      }, error => {
        this.$message({
          showClose: true,
          message: error.data.msg,
          type: 'error'
        });
      })
    },
    phoneChange(){
      if((/^1[3456789]\d{9}$/.test(this.phoneNumber))) {
        this.phoneflg = true;
        if(this.yzmNum != ''){
          this.yzmflg = true;
        }
      }else {
        this.phoneflg = false;
      }
    },
    yzmChange(){
      if(this.yzmNum != '' && this.phoneflg) {
        this.yzmflg = true;
      }else {
        this.yzmflg = false;
      }
    },
    isActive(route) {
      return this.$route.path === route;
    },
    goHome() {
      this.$router.push({ path: '/' });
    },
    gotoPath(item){
      this.$router.push({ path: item.path });
    }
  }

}
</script>

<style lang="scss" scoped>
.elheaderbox {
  height: 1.2rem !important; 
}
.brbuttonbox {
  padding: 0 !important;
  border: none !important;
  &:hover {
    background: none !important;
  }
}
.topview {
  box-shadow: 0 4px 36px -9px rgba(0, 0, 0, 0.25);
  position: fixed;
  z-index: 99;
  left: 0;
  top: 0;
  right: 0;
  height: 1.2rem;
  color: #333;
  display: flex;
  align-items: center;
  padding: 0 0.6rem;
  background: #fff;
  min-width: 13.66rem;
  .left {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    .img {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: .11rem;
    }
    .span1 {
      font-size: 0.18rem;
      text-align: left;
      margin-bottom: .04rem;
      font-weight: 800;
    }
    .span2 {
      font-size: 0.14rem;
      white-space: nowrap;
    }
    .span3 {
      margin-top: 0.04rem;
      font-size: 0.14rem;
      white-space: nowrap;
      text-align: left;
      color: #F96F02;
    }
  }
  .right {
    display: inline-flex;
    flex: auto;
    justify-content: right;
    align-items: center;
    color: #333;
    span {
      font-size: 0.2rem;
    }
    .rightitem1 {
      &.active span {
        color: #F96F02;
      }
      &.active span::before {
        content: '';
        position: absolute;
        height: .04rem;
        width: 100%;
        background: #F96F02;
        bottom: -0.1rem;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .rightitem {
      padding: 0.24rem;
      cursor: pointer;
      margin-left: 0.48rem;
      white-space: nowrap;
      &:hover span {
        font-weight: bold;
      }
    }
    .rightitem2 span::before {
      content: '';
      display: inline-block;
      width: 0.2rem;
      height: 0.2rem;
      background: url('https://csstss.cn/consumer/2024-11-21/3a2df3a8-7d54-46c6-b19a-b78538f7b33d.png') no-repeat;
      background-size: 100% 100%;
      vertical-align: middle;
      margin-right: .1rem;
    }
  }
}
.dropdownbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.36rem;
  width: 3.1rem;
  .dropdownitem {
    text-align: center;
    img {
      width: 1rem;
      height: 1rem;
    }
    .text {
      text-align: center;
      font-size: .14rem;
      color: #333333;
      line-height: 0.16rem;
      letter-spacing: 2px;
      
    }
  }
}
.loginbox {
  margin-left: 0.48rem;
  .loginbtn {
    cursor: pointer;
    width: 1rem;
    height: 0.38rem;
    line-height: 0.38rem;
    border-radius: 4px;
    border: 1px solid #333;
    box-sizing: border-box;
    text-align: center;
    color: #333;
    background: none !important;
    padding: 0;
    p {
      font-size: 0.2rem;
    }
    &:hover {
      border: 1px solid #FA7105;
      box-sizing: border-box;
    }
    &:hover p {
      color: #FA7105;
    }
  }
  .loginokitem {
    display: flex;
    align-items: center;
    img {
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 50%;
      margin-right: 0.1rem;
    }
    span {
      color: #999;
      font-size: 0.16rem;
    }
  }
}
.el-button:hover {
  color: #FA7105;
}


.login-content {
    width: 10rem;
    height: 80%;
}
.login-content input {
    text-indent: 1em;
    font-size: 0.22rem;
}
.login-content .from-box {
    width: 8rem;
    height: 5.18rem;
}
.login-content .from-box h3 {
    font-size: 0.28rem;
    color: #666;
    text-align: center;
    cursor: pointer;
}
.login-content .from-box .number-ipt {
    width: 8rem;
    height: 0.94rem;
    margin-bottom: .4rem;
    border: 1px solid #DADADA;
}
.login-content .from-box .yzm-ipt {
    width: 8rem;
    height: 0.94rem;
    border: 1px solid #DADADA;
}
.login-content .from-box .text-ma .ma-box {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 1.55rem;
    cursor: pointer;
    right: 0.4rem;
    &::before {
      content: '';
      display: block;
      margin-right: 0.3rem;
      width: 2px;
      height: 0.3rem;
      background: #DADADA;
    }
}
.login-content .from-box .text-ma .get-ma-three {
    justify-content: space-around;
    color: #F96F02;
    cursor: default;
}
.login-content .from-box .text-ma .ma-box-dwon {
    cursor: pointer;
}
.login-content .from-box .text-ma .ma-box-dwon img {
    width: 100%;
    height: 100%;
}
.login-content .from-box .text-ma .ma-box-dwon span {
    font-size: 12px;
    bottom: -17px;
    color: #888;
    width: 80px;
}
.login-content .from-box button {
  width: 8rem;
  height: .94rem;
  border-radius: 6px;
  line-height: 0.94rem;
  font-size: .3rem;
  letter-spacing: 4px;
  color: #fff;
  border: none;
  margin-top: 0.6rem;
}
.login-content .from-box .submit-btn {
  background: linear-gradient( 90deg, #FEC335 0%, #F96F03 100%);
  cursor: pointer;
}
.login-content .from-box .old-btn {
  background: #ccc;
}
.text-ma-sj .ma-box {
    font-size: .22rem;
    text-align: center;
    color: #ccc;
}
.text-ma-sj .get-ma-two {
    cursor: pointer;
    color: #F96F02;
}
.from-box .logo-bott {
    margin-top: 10px;
}
.from-box .logo-bott p {
    font-size: 0.22rem;
    line-height: 0.4rem;
    color: #999;
  }
.from-box .logo-bott p a {
    font-size: 0.22rem;
    color: #F96F02;
}
.bg-sel {
    color: #ccc !important;
    cursor: default !important;
}
.border-black {
    border: 1px solid #000 !important;
}
.formboxtitle {
  height: 97px;
  line-height: 97px;
  display: flex;
  justify-content: center;
  .psdflg {
    margin-right: 1.38rem;
  }
  h3 {
    font-weight: bold;
    &.active {
      color: #F96F02;
    }
  }
}
.fromselcolor {
    color: #000 !important;
}
.fromewmbox img {
    width: 3.6rem;
    height: 3.6rem;
}
.fromewmbox p {
    white-space: nowrap;
    font-size: 0.22rem;
    margin-top: 20px;
    color: #999;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}
/* 提示语 */
.tishi-div {
    bottom: -5px;
    height: 20px;
}
.tishi-div .tishi-x {
    font-size: 24px;
    color: red;
    vertical-align: top;
}
.tishi-div .tishi-text {
    font-size: 14px;
    color: red;
}
/* 安全验证 */
.yz-layer-box {
    width: 100%;
    height: calc(100% - 1rem);
    overflow: hidden;
    top: 1rem;
    background: rgba(0,0,0,0.5);
    z-index: 81;
    // min-width: 1366px;
}
.yz-layer-box h3 {
    font-size: 0.18rem;
    text-align: center;
    line-height: 69px;
    padding-top: 20px;
}
.yz-layer-box .captcha-box {
    width: 360px;
    height: 360px;
    background: #fff;
    top: 60px;
    right: 375px;
}
.close-yz-layer {
    width: 24px;
    top: 20px;
    right: 20px;
    cursor: pointer;
}
.vue-puzzle-vcode {
  z-index: 99999;
}
</style>
